import { Product } from "../productsData";

function getAllHalfSleeveDawaTShirtsData(): Product[] {
  return [
    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "behind-every-delay-there-is-goodness",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/behind-every-delay-there-is-goodness",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662313395/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd210-turkish-920x920_dbt70q.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663306133/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd210-khaki-scaled-920x920_jpi24r.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393457/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd210-turkish-350x435_xjvevu.jpg",
      name: "Behind Every Delay There Is Goodness",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["TURKISH", "KHAKI"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "assalamu-alaikum-v5-2",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/assalamu-alaikum-v5-2",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662352274/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd196-black-920x920_uvta18.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297313/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd196-turkish-blue-1-920x920_rspmnv.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297328/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd196-biscuit-920x920_ia0ybm.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297334/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd196-white-920x920_xrzfwu.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393500/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd196-black-350x435_lrnu0w.jpg",
      name: "Assalamu Alaikum V5",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Turkish Blue", "Biscuit", "White", "Black"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "dua",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/dua",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662352456/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd197-turkish-blue-920x920_jfecpp.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297439/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd197-maroon-scaled-920x920_cmbfte.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297421/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd197-black-scaled-920x920_dig1jz.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297431/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd197-khaki-scaled-920x920_u6jdty.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393544/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd197-turkish-blue-350x435_oodnh2.jpg",
      name: "Dua",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Turkish Blue", "Maroon", "Black", "Khaki"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "made-of-dust",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/made-of-dust",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662352579/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd207-black-920x920_j7btbu.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297566/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd207-maroon-scaled-920x920_onst1r.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297557/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd207-turkish-blue-scaled-920x920_hepshm.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297551/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd207-biscuit-scaled-920x920_oxy2pm.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393621/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd207-black-350x435_kp8nqc.jpg",
      name: "Made of dust",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Maroon", "Turkish Blue", "Biscuit"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "prophet-muhammadsm-my-hero",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/prophet-muhammadsm-my-hero",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662352699/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd31-turkish-blue-920x920_txgt0i.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297760/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd31-biscuit-scaled-920x920_dhzn7w.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297751/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd31-black-scaled-920x920_eayctt.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297746/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd31-bottle-green-scaled-920x920_pzcr4r.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393681/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd31-turkish-blue-350x435_gbwqgg.jpg",
      name: "Prophet Muhammad(sm) My Hero",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Turkish Blue", "Biscuit", "Black", "Bottle Green"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "what-you-got-losing-your-rabb",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/what-you-got-losing-your-rabb",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662352802/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd209-black-920x920_fteez3.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297864/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd209-bottle-green-scaled-920x920_hd2o4s.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297858/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd209-deep-ash-scaled-920x920_qcob5v.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297851/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd209-turkish-blue-scaled-920x920_dwaefg.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393734/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd209-black-350x435_glldxk.jpg",
      name: "What He got Losing His Rabb!",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Bottle Green", "Deep Ash", "Turkish Blue"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "god-is-one",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/god-is-one",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662353127/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd206-navy-920x920_hz64uq.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297954/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd206-ardoise-920x920_ivrspn.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297947/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd206-biscuit-920x920_olmhoy.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663297940/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd206-black-920x920_hxfkgf.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393781/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd206-navy-350x435_abtace.jpg",
      name: "God Is One",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Navy", "Ardoise", "Biscuit", "Black"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "salaf-ways",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/salaf-ways",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662353213/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd205-black-920x920_xlanng.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298053/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd205-anthra-920x920_dcu6st.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298046/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd205-deep-ash-920x920_sq0pol.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298039/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd205-bottle-green-920x920_va8suo.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393829/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd205-black-350x435_kwx5un.jpg",
      name: "Salaf Ways",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Anthra", "Deep Ash", "Bottle Green"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "i-am-muslim-v2",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/i-am-muslim-v2",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662353375/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd203-navy-920x920_mppb0u.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298197/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd203-turkish-blue-4-920x920_ql3hbo.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298191/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd203-maroon-920x920_pcvoqi.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298186/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd203-dark-olive-920x920_scqezp.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393882/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd203-navy-350x435_jjykoe.jpg",
      name: "I Am Muslim",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Navy", "Turkish Blue", "Maroon", "Dark Olive"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "nirob-thaka",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/nirob-thaka",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662353469/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd202-navy-920x920_xc2vxo.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298295/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd202-biscuit-920x920_giajma.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298280/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd202-Turkish-blue-920x920_zgzvln.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298275/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd202-gray-mist-920x920_wnmexj.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393924/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd202-navy-350x435_bzevfg.jpg",
      name: "Nirob Thaka",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Navy", "Biscuit", "Turkish Blue", "Gray Mist"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "assalamu-alaikum-v6-2",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/assalamu-alaikum-v6-2",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662353560/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd201-black-920x920_psx59f.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298393/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd201-Turkish-blue-920x920_q0bmaz.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298387/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd201-deep-ash-920x920_nqtmyq.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298380/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd201-navy-1-920x920_ccvbzu.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393977/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd201-black-350x435_a07nom.jpg",
      name: "Assalamu Alaikum v6",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Black", "Turkish Blue", "Deep Ash", "Navy"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "muslim-24-7",
      fullPath: "/half-sleeve-dawah-tshirts-for-men/product/muslim-24-7",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662353640/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd200-Turkish-blue-920x920_kqnlps.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298490/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd200-deep-ash-1-920x920_twijpm.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298484/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd200-black-920x920_g6dhvk.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663298475/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd200-white-920x920_gewcqk.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662394049/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd200-Turkish-blue-350x435_l4swby.jpg",
      name: "Muslim 24/7",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Turkish Blue", "Deep Ash", "Black", "White"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "people-forgets-and-allah-forgive",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/people-forgets-and-allah-forgive",
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662307441/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd212-ardoise-350x435_nboxaq.jpg",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393290/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd212-ardoise-920x920_bmfusy.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663296324/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd212-navy-scaled_qfj1if.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663296328/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd212-black-scaled-920x920_dbz7g9.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663296343/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd212-bottle-green-scaled-920x920_h7pjpm.jpg",
      ],
      name: "People Forgets and Allah Forgives",
      price: "৳ 320.00",
      details: [
        "Regular fit, Crew Neck, Comfortable to wear",
        "170 GSM",
        "Reactive Dye, Heavy Enzyme and silicon wash ( Azo Free) ",
        "Mid Peach finished ",
        "Soft Hand feel and Compact Finished",
      ],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["Turkish Blue", "Navy", "Black", "Bottle Green"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },

    {
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE DAWAH T-SHIRTS",
          path: "/half-sleeve-dawah-tshirts-for-men",
        },
      ],
      pathName: "pray-like-its-your-last-day",
      fullPath:
        "/half-sleeve-dawah-tshirts-for-men/product/pray-like-its-your-last-day",
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662312583/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd211-khaki-920x920_dkxgvn.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663296889/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd211-anthra-scaled-920x920_d1xn7x.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663296898/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd211-navy-scaled-920x920_q1ulfz.jpg",
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663296907/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/mthrsd211-ardoise-scaled-920x920_sop0a7.jpg",
      ],
      imgForProductCard:
        "https://res.cloudinary.com/du3oueesv/image/upload/v1662393384/shopping%20cart/half%20sleeve%20dawa%20t%20shirts/image%20for%20productCards/mthrsd211-khaki-350x435_i3clje.jpg",
      name: "Pray Like It's Your Last Day",
      price: "৳ 320.00",
      details: [],
      fabric: ["CARD COTTON", "VISCOSE COTTON", "COMBED COTTON"],
      color: ["khaki", "anthra", "navy", "ardoise"],
      size: ["S", "M", "L", "XL", "XXL"],
      description: [
        "S(Small): Chest 37.79″ inch/ 96 cm, Height 26.77″inch/ 68 cm",
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "CARD COTTON, VISCOSE COTTON, COMBED COTTON",
        size: "S, M, L, XL, XXL",
      },
    },
  ];
}

export default getAllHalfSleeveDawaTShirtsData;

function getSpecificHalfSleeveDawaTShirtData(searchPath: string) {
  return (
    getAllHalfSleeveDawaTShirtsData().find((product) => {
      const productPath = product.pathName;
      return productPath === searchPath;
    }) || getAllHalfSleeveDawaTShirtsData()[0]
  );
}

export { getSpecificHalfSleeveDawaTShirtData };
